import {Component, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {TargetGroupSettingService} from '../../../../../core/services/targetGroupSetting.service';
import {ActivatedRoute} from '@angular/router';
import {fuseAnimations} from '../../../../../core/animations';
import {TranslateService} from '@ngx-translate/core';
import {TargetGroupService} from '../../../../../core/services/targetGroup.service';
import {SubCreditTargetService} from '../../../../../core/services/subCreditTarget.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SubCreditTargetFormDialogComponent} from './setting-form/setting-form.component';
import {FrontUserService} from '../../../../../core/services/frontUsers.service';
import {FuseDeleteDialogComponent} from '../../../../../core/components/delete-dialog/delete-dialog.component';
import {NewCreditTargetComponent} from './new-credit-target/newCreditTarget.component';

@Component({
    selector: 'target-group-setting-page',
    templateUrl: './target-group-setting.component.html',
    styleUrls: ['./target-group-setting.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class TargetGroupSettingComponent implements OnInit {
  public formGroup: FormGroup = new FormGroup({
    active: new FormControl(''),
    title: new FormControl('', Validators.required),
    creditTarget: new FormControl('', Validators.required),
    maxTransfer: new FormControl('', Validators.required),
  });

  public img: any = '';
  public uploadedImg = null;
  public id;
  public targetGroupId;
  public name;
  subCreditTargets: any;
  newSubCreditTargets: any = [];
  remain;
  dialogRef: any;
  widget6: any = {
    legend: true,
    explodeSlices: false,
    labels: true,
    doughnut: true,
    gradient: false,
    arcWidth: 0.5,
    scheme: {
      domain: []
    }
  };
  data = [];
  defaultData;
  archivedSettings: any = [];

  constructor(private targetGroupSettingService: TargetGroupSettingService, private targetGroupService: TargetGroupService,
              private subCreditTargetService: SubCreditTargetService, public dialog: MatDialog, public snackBar: MatSnackBar,
              public translate: TranslateService, private route: ActivatedRoute,
              private frontUserService: FrontUserService) {
    this.subCreditTargetService.onSubCreditTargetChanged.subscribe((res: any) => {
      this.subCreditTargets = res;
      this.widget6.scheme.domain = [];
      this.data = [];
      this.calculateRemains();
    });
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.id = this.route.snapshot.queryParamMap.get('id');
    this.targetGroupId = this.route.snapshot.queryParamMap.get('targetGroupId');
    this.targetGroupService.getTargetGroupById(this.targetGroupId).subscribe((res: any) => {
      this.name = res.ageMask + ' - ' + res.targetNumber;
    });
    if (this.id) {
      this.subCreditTargetService.setId(this.id);
      this.targetGroupSettingService.getTargetGroupSettingById(this.id).subscribe((res: any) => {
        this.defaultData = res;
        if (res.archivedSettings) {
          this.archivedSettings = res.archivedSettings;
        }
        this.formGroup.patchValue(res);
        this.getDataType();
        this.calculateRemains();
      });
    }
  }

  getDataType() {
    this.subCreditTargetService.getSubCreditTargets().then();
  }

  addTargetGroupSetting() {
    const data = this.formGroup.value;
    data.targetGroupId = this.targetGroupId;
    data.id = parseInt(this.id, 10);

    if (this.defaultData) {
      if ((+data.creditTarget !== +this.defaultData.creditTarget)) {
        const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
          width: '300px',
          data: {title: 'change_tg_setting', message: 'change_tg_setting_msg'}
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.addTGFunc(data, true);
          }
        });
      } else if ((+data.creditTarget === +this.defaultData.creditTarget) && (this.newSubCreditTargets.length || (+data.maxTransfer !== +this.defaultData.maxTransfer))) {
        const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
          width: '300px',
          data: {title: 'add_sub_credit_title', message: 'add_sub_credit_msg'}
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.addSubCT();
            this.addTGFunc(data, false, false);
          } else {
            this.addTGFunc(data, true, true);
          }
        });
      } else {
        this.addTGFunc(data, false);
      }
    } else {
      this.addTGFunc(data, false);
    }
  }

  addTGFunc(data, updateSubCT = false, createNew = false) {
    data.createNew = createNew;
    this.targetGroupSettingService.addTargetGroupSetting(data).subscribe((res: any) => {
      if (res) {
        if (updateSubCT) {
          this.subCreditTargetService.updateSubCreditTargetByTGSId(this.id, res.id).subscribe(sc => {
            this.subCreditTargetService.setId(res.id);
            this.getDataType();
          });
          if (this.newSubCreditTargets.length) {
            for (let i = 0; i < this.newSubCreditTargets.length; i++) {
              this.newSubCreditTargets[i].targetGroupSettingId = res.id;
            }
            this.addSubCT();
          }
        }
        this.archivedSettings = [];
        this.id = res.id;
        if (!updateSubCT) {
          this.subCreditTargetService.setId(this.id);
          this.getDataType();
        }
        if (res.archivedSettings) {
          this.archivedSettings = res.archivedSettings;
        }
        this.formGroup.patchValue(res);
        this.calculateRemains();
        if (!this.defaultData || (+this.defaultData.creditTarget !== +res.creditTarget)) {
          this.snackBar.open('Target Group Setting was added.', '', {duration: 2500});
        } else {
          this.snackBar.open('Target Group Setting was edited.', '', {duration: 2500});
        }
        this.defaultData = res;
        this.frontUserService.updateAllYearsRewards('', res.organizationId).subscribe(result => {

        });
      }
    });
  }

  addNewTargetGroupSetting() {
    this.dialogRef = this.dialog.open(NewCreditTargetComponent, {
      panelClass: 'contact-form-dialog',
      width: '500px'
    });
    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response) {
          const data = response.value;
          data.targetGroupId = this.targetGroupId;
          data.active = this.defaultData.active;
          this.addTGFunc(data, false, true);
        }
      });
  }

  addSubCreditTarget() {
    this.dialogRef = this.dialog.open(SubCreditTargetFormDialogComponent, {
      panelClass: 'contact-form-dialog',
      width: '350px',
      data: {
        action: 'new',
        remain: this.remain,
        data: this.subCreditTargets
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        const data = response[0].value;
        data.targetGroupSettingId = this.id;
        data.eventType = response[1];
        this.newSubCreditTargets.push(data);
        this.calculateRemains();

      });
  }

  addSubCT() {
    this.subCreditTargetService.addSubCreditTarget(this.newSubCreditTargets).subscribe((res) => {
      if (res) {
        this.newSubCreditTargets = [];
        this.subCreditTargetService.getSubCreditTargets().then();
      }
    }, error => {
      this.snackBar.open('Add failed.', '', {duration: 2500});
    });
  }

  editSubCreditTarget(level) {
    this.dialogRef = this.dialog.open(SubCreditTargetFormDialogComponent, {
      panelClass: 'contact-form-dialog',
      width: '350px',
      data: {
        type: level,
        action: 'edit',
        remain: this.remain,
        data: this.subCreditTargets
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        // console.log(response);
        const actionType: string = response[0];
        const data = response[1].value;
        data.id = level.id;

        const checkDialog = this.dialog.open(FuseDeleteDialogComponent, {
          width: '600px',
          data: {title: 'change_sub_ct', message: 'change_sub_ct_msg'}
        });
        checkDialog.afterClosed().subscribe(result => {
          if (result) {
            switch (actionType) {
              /**
               * Save
               */
              case 'save':


                this.subCreditTargetService.addSubCreditTarget(data).subscribe((res) => {
                  if (res) {
                    this.snackBar.open('Sub Credit Target updated.', '', {duration: 2500});
                    this.subCreditTargetService.getSubCreditTargets().then();
                  }
                }, error => {
                  this.snackBar.open('Update failed.', '', {duration: 2500});
                });
                break;
              /**
               * Delete
               */
              case 'delete':
                this.subCreditTargetService.deleteSubCreditTarget(level.id).subscribe((res) => {
                  if (res) {
                    this.snackBar.open('Sub Credit Target  deleted.', '', {duration: 2500});
                    this.subCreditTargetService.getSubCreditTargets().then();
                  }
                }, error => {
                  this.snackBar.open('Delete failed.', '', {duration: 2500});
                });

                break;
            }
          }
        });
      });
  }

  removeNewSubCreditTarget(index) {
    this.newSubCreditTargets.splice(index, 1);
  }

  calculateRemains() {
    let remainsText = this.translate.instant('remains_small');
    if (this.formGroup && this.formGroup.value && (this.subCreditTargets.length || this.newSubCreditTargets.length) && this.formGroup.value.creditTarget) {
      let totalSubCreditTarget = 0;
      for (let i = 0; i < this.subCreditTargets.length; i++) {
        totalSubCreditTarget = totalSubCreditTarget + this.subCreditTargets[i].credit;
        this.widget6.scheme.domain.push(this.subCreditTargets[i].eventType.color);
        this.data.push({name: (i + 1) + '.' + this.subCreditTargets[i].eventType.name, value: this.subCreditTargets[i].credit});
      }
      let newTotalSubCreditTarget = 0;
      for (let i = 0; i < this.newSubCreditTargets.length; i++) {
        newTotalSubCreditTarget = newTotalSubCreditTarget + +this.newSubCreditTargets[i].credit;
        this.widget6.scheme.domain.push(this.subCreditTargets[i].eventType.color);
        this.data.push({name: (i + 1) + '.' + this.newSubCreditTargets[i].eventType.name, value: this.newSubCreditTargets[i].credit});
      }
      this.widget6.scheme.domain.push('#000000');
      this.remain = this.formGroup.value.creditTarget - totalSubCreditTarget - newTotalSubCreditTarget;
      this.data.push({name: remainsText, value: this.remain});
    } else if (this.formGroup && this.formGroup.value && this.formGroup.value.creditTarget) {
      this.remain = this.formGroup.value.creditTarget;
      this.data.push({name: remainsText, value: this.remain});
    } else {
      this.remain = 0;
      this.data.push({name: remainsText, value: this.remain});
    }
  }
}
